"use strict";

angular.module(ApplicationConfiguration.applicationModuleName).factory("Chat", [
  "$rootScope",
  "apiSettings",
  function ($rootScope, apiSettings) {
    var proxy;
    var connection;
    var chat;

    return {
      connect: function (userId, colorsRequestId) {
        angular.element.connection.chatHub.client.broadcastMessage = function ({
          chatEvent,
          payload,
        }) {

          if (chatEvent == "NewMessage") {
            $rootScope.$broadcast("newMessage", { chatEvent, payload });
          } else if (chatEvent == "Error") {
            /* $rootScope.$broadcast('newMessage', {chatEvent, payload}); */
          }
        };

        angular.element.connection.chatHub.client.receiveNotification =
          function (event, payload) {
            $rootScope.$broadcast("receiveNotification", event, payload);
          };

        angular.element.connection.chatHub.client.broadcastOnLine = function (
          chatEvent
        ) {
          $rootScope.$broadcast("userOnLine", chatEvent);
        };

        chat = angular.element.connection.chatHub;
        connection = angular.element.hubConnection();

        angular.element.connection.hub.url = apiSettings.chatUri;
        angular.element.connection.hub
          .start({ jsonp: true })
          .done(function () {
            $rootScope.$broadcast("chatStarted");
            if (!chat) return;
            if (chat.server) {
              chat.server.registerConnection(userId, colorsRequestId);
            } else {
              return;
            }
          })
          .fail(function (e) {
          });
      },
      isConnecting: function () {
        return connection.state === 0;
      },
      isConnected: function () {
        return connection.state === 1;
      },
      connectionState: function () {
        return connection.state;
      },

      sendMessage: function (userId, colorsRequestId, message) {
        if (!chat) return;
        if (chat.server) {
          chat.server.sendMessage(userId, colorsRequestId, message);
        }
      },

      sendImageMessage: function (userId, colorsRequestId, imageUrl) {
        if (!chat) return;
        if (chat.server) {
          chat.server.sendImageMessage(userId, colorsRequestId, imageUrl);
        }
      },

      markAllAsRead: function (userId, colorsRequestId) {
        if (!chat) return;
        if (chat.server) {
          chat.server.markAllAsRead(userId, colorsRequestId);
        }
      },

      exitChat: function (userId, colorsRequestId) {
        if (!chat) return;
        if (chat.server) {
          chat.server.exitChat(userId, colorsRequestId);
        }
      },
    };
  },
]);
